import React from "react";
import { migraUsuarioPaso as baseTitles } from "consts/titulos-de-tablas";

export const SEMAFORO_COLORS = { V: "#4caf50", A: "#ff9800", R: "#f44336" };

export const ESTADO_LABELS = {
    P: "Pendiente",
    V: "Vencido",
    C: "Completado",
    A: "Con Alarma",
    B: "Bloqueado",
};

export const migraUsuarioPasoColumns = baseTitles.map((t) => {
    if (t.field === "migraUsuarioPasoSemaforo") {
        return {
            ...t,
            renderCell: ({ value }) => {
                const color = SEMAFORO_COLORS[value];
                if (!color) return null;
                return (
                    <span
                        style={{
                            display: "inline-block",
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            backgroundColor: color,
                        }}
                    />
                );
            },
        };
    }
    if (t.field === "migraUsuarioPasoEstado") {
        return {
            ...t,
            valueGetter: ({ value }) => ESTADO_LABELS[value] ?? value ?? "",
        };
    }
    return t;
});

export function mapMigraUsuarioPasoRow(item) {
    const {
        migraUsuarioPasoId,
        usuarioId,
        usuarioApellidos,
        usuarioNombres,
        usuarioNroDeDocumentoX,
        tipoDeDocumentoCod,
        tipoDeDocumentoNombre,
        usuarioSexo,
        usuarioFechaDeNacimiento,
        migraUsuarioPasoPasoId,
        migraPasoNombre,
        migraUsuarioPasoTipo,
        migraUsuarioPasoFechaCreacion,
        migraUsuarioPasoFechaCheckin,
        migraUsuarioPasoEstado,
        migraUsuarioPasoSemaforo,
        migraUsuarioPasoIdentificacion,
        migraUsuarioPasoOrigenDestino,
        migraUsuarioPasoAutenticacionId,
        migraUsuarioPasoLatitud,
        migraUsuarioPasoLongitud,
        migraUsuarioPasoVersion,
        migraVueloId,
    } = item;

    return {
        id: migraUsuarioPasoId,
        migraUsuarioPasoId,
        usuarioId,
        migraUsuarioPasoPasoId,
        migraUsuarioPasoVersion,
        migraUsuarioPasoSemaforo,
        migraVueloId,
        apellidoYNombre: [usuarioApellidos, usuarioNombres].filter(Boolean).join(", "),
        usuarioApellidos,
        usuarioNombres,
        usuarioNroDeDocumentoX,
        tipoDeDocumentoCod,
        tipoDeDocumentoNombre,
        usuarioSexo,
        usuarioFechaDeNacimiento,
        migraPasoNombre,
        migraUsuarioPasoTipo,
        migraUsuarioPasoFechaCreacion,
        migraUsuarioPasoFechaCheckin,
        migraUsuarioPasoEstado,
        migraUsuarioPasoIdentificacion,
        migraUsuarioPasoOrigenDestino,
        migraUsuarioPasoAutenticacionId,
        migraUsuarioPasoLatitud,
        migraUsuarioPasoLongitud,
    };
}
